import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    label: {
      '&+.MuiInput-formControl': {
        marginTop: 0
      }
    },
    input: {
      textAlign: 'center',
      fontSize: '32px',
      lineHeight: '38px',
    },
    help: {
      textAlign: 'center',
    },
    proposedSumWrap: {
      marginTop: theme.spacing(1),
    },
    proposedSum: {
      padding: '7px 19px',
      margin: '0 11px',
      border: '1px solid rgba(26,17,24,.2)',
      borderRadius: '18px',
      color: 'rgba(26,17,24,.6)',

      [theme.breakpoints.up('md')]: {
        minWidth: 'initial',
        padding: '0 5px',
        fontSize: '12px'
      },
    },
    proposedSumFilled: {
      color: '#000',
      backgroundColor: 'rgba(26, 17, 24, 0.08)',
      border: '1px solid rgba(26,17,24,.6)',
    }
  })
);
